<inm-panel [formGroup]="outboundFeedFormGroup">
  <div class="row">
    <div class="col-6">
      <inm-input-container [label]="'obf_form.fields.feedType.label' | staticContent">
        <inm-tree-select
          [items]="feedType"
          [multiple]="false"
          valueKey="value"
          labelKey="label"
          [placeholder]="'obf_form.fields.feedType.placeholder' | staticContent"
          formControlName="feedType"
          class="inm-textinput__input"
          >
        </inm-tree-select>

        @if (
          outboundFeedFormGroup.controls.feedType.invalid &&
          (outboundFeedFormGroup.controls.feedType.dirty || outboundFeedFormGroup.controls.feedType.touched)
          ) {
          <inm-validation-message
            [control]="outboundFeedFormGroup.controls.feedType"
            [label]="'obf_form.fields.feedType.label' | staticContent"
            >
          </inm-validation-message>
        }
      </inm-input-container>
    </div>
    @if (outboundFeedFormGroup.controls.feedType?.value && outboundFeedFormGroup.controls.feedType?.value === 'FT2') {
      <div class="col-6">
        <span class="inm-subheading inm-mid-blue-text mb-3">{{
          'obf_form.fields.sendEmptyFile.label' | staticContent
        }}</span>
        <inm-toggle onLabel="Yes" offLabel="No" formControlName="sendEmptyFile"> </inm-toggle>
      </div>
    }
  </div>
  <div class="row">
    <div class="col-6">
      <inm-input-container [label]="'obf_form.fields.feedFormat.label' | staticContent">
        <inm-tree-select
          [items]="feedFormat"
          valueKey="value"
          labelKey="label"
          [placeholder]="'obf_form.fields.feedFormat.placeholder' | staticContent"
          formControlName="feedFormat"
          [disable]="
            outboundFeedFormGroup.controls.feedType.value === null ||
            outboundFeedFormGroup.controls.feedType.value === undefined
          "
          #treeSelectFeedFormat
          >
        </inm-tree-select>

        @if (
          outboundFeedFormGroup.controls.feedFormat.invalid &&
          (outboundFeedFormGroup.controls.feedFormat.dirty || outboundFeedFormGroup.controls.feedFormat.touched)
          ) {
          <inm-validation-message
            [control]="outboundFeedFormGroup.controls.feedFormat"
            [label]="'obf_form.fields.feedFormat.label' | staticContent"
            >
          </inm-validation-message>
        }
      </inm-input-container>
    </div>
    <div class="col-6">
      <span class="inm-subheading inm-mid-blue-text">{{ 'obf_form.fields.zip.label' | staticContent }}</span>
      <inm-toggle onLabel="Yes" offLabel="No" formControlName="zip"> </inm-toggle>
    </div>
  </div>
  <div class="row">
    <div class="col-6">
      <inm-input-container [label]="'obf_form.fields.feedFrequency.label' | staticContent">
        <inm-tree-select
          [items]="feedFrequency"
          valueKey="value"
          [multiple]="true"
          labelKey="label"
          [placeholder]="'obf_form.fields.feedFrequency.placeholder' | staticContent"
          formControlName="feedFrequency"
          [disable]="
            outboundFeedFormGroup.controls.feedFormat.value === null ||
            outboundFeedFormGroup.controls.feedFormat.value === undefined
          "
          class="inm-textinput__input"
          #treeSelectFeedFrequency
          >
        </inm-tree-select>

        @if (
          outboundFeedFormGroup.controls.feedFrequency.invalid &&
          (outboundFeedFormGroup.controls.feedFrequency.dirty || outboundFeedFormGroup.controls.feedFrequency.touched)
          ) {
          <inm-validation-message
            [control]="outboundFeedFormGroup.controls.feedFrequency"
            [label]="'obf_form.fields.feedFrequency.label' | staticContent"
            >
          </inm-validation-message>
        }
      </inm-input-container>
    </div>
    @if (outboundFeedFormGroup.controls.zip.value) {
      <inm-input-container [label]="'.fields.zipPassword.label' | staticContent" class="col-6" [optional]="true">
        <input
          type="text"
          [placeholder]="'.fields.zipPassword.placeholder' | staticContent"
          formControlName="zipPassword"
          class="inm-textinput__input"
          />
          @if (
            outboundFeedFormGroup.controls.zipPassword.invalid &&
            (outboundFeedFormGroup.controls.zipPassword.dirty || outboundFeedFormGroup.controls.zipPassword.touched)
            ) {
            <inm-validation-message
              [control]="outboundFeedFormGroup.controls.zipPassword"
              [label]="'.fields.zipPassword.label' | staticContent"
              >
            </inm-validation-message>
          }
        </inm-input-container>
      }
    </div>

    <div class="row">
      <div class="col-6">
        <inm-input-container [label]="'obf_form.fields.delivery.label' | staticContent">
          <inm-tree-select
            [items]="delivery"
            valueKey="value"
            [multiple]="true"
            labelKey="label"
            [placeholder]="'obf_form.fields.delivery.placeholder' | staticContent"
            formControlName="delivery"
            class="inm-textinput__input"
          [disable]="
            outboundFeedFormGroup.controls.feedFrequency.value === null ||
            outboundFeedFormGroup.controls.feedFrequency.value === undefined ||
            outboundFeedFormGroup.controls.feedFrequency.value.length === 0
          "
            #treeSelectDelivery
            >
          </inm-tree-select>

          @if (
            outboundFeedFormGroup.controls.delivery.invalid &&
            (outboundFeedFormGroup.controls.delivery.dirty || outboundFeedFormGroup.controls.delivery.touched)
            ) {
            <inm-validation-message
              [control]="outboundFeedFormGroup.controls.delivery"
              [label]="'obf_form.fields.delivery.label' | staticContent"
              >
            </inm-validation-message>
          }
        </inm-input-container>
      </div>
      @if (showDeliveryFields(outboundFeedDeliveryValue.SFTP)) {
        <div class="col-6">
          <inm-input-container [label]="'.fields.directory.label' | staticContent">
            <input
              type="text"
              [placeholder]="'.fields.directory.placeholder' | staticContent"
              formControlName="directory"
              class="inm-textinput__input"
              />
              @if (
                outboundFeedFormGroup.controls.directory.invalid &&
                (outboundFeedFormGroup.controls.directory.dirty || outboundFeedFormGroup.controls.directory.touched)
                ) {
                <inm-validation-message
                  [control]="outboundFeedFormGroup.controls.directory"
                  [label]="'obf_form.fields.directory.label' | staticContent"
                  >
                </inm-validation-message>
              }
            </inm-input-container>
          </div>
        }
      </div>

      @if (showDeliveryFields(outboundFeedDeliveryValue.EMAIL)) {
        <div class="row">
          <div class="col-6">
            <inm-input-container [label]="'.fields.emailAddress.label' | staticContent">
              <textarea
                type="text"
                [placeholder]="'.fields.emailAddress.placeholder' | staticContent"
                formControlName="emailAddress"
                [maxLength]="255"
                class="inm-textinput__input h-35r"
                >
              </textarea>
              @if (
                outboundFeedFormGroup.controls.emailAddress.invalid &&
                (outboundFeedFormGroup.controls.emailAddress.dirty || outboundFeedFormGroup.controls.emailAddress.touched)
                ) {
                <inm-validation-message
                  [control]="outboundFeedFormGroup.controls.emailAddress"
                  [label]="'.fields.emailAddress.label' | staticContent"
                  >
                </inm-validation-message>
              }
              <small class="text-muted float-end"
                >{{ outboundFeedFormGroup.controls?.emailAddress?.value?.length || 0 }} / 255</small
                >
              </inm-input-container>
            </div>
            <div class="col-6">
              <inm-input-container [label]="'.fields.ccEmailAddress.label' | staticContent" [optional]="true">
                <textarea
                  [placeholder]="'.fields.ccEmailAddress.placeholder' | staticContent"
                  formControlName="ccEmailAddress"
                  class="inm-textinput__input h-35r"
                  >
                </textarea>
                @if (
                  outboundFeedFormGroup.controls.ccEmailAddress.invalid &&
                  (outboundFeedFormGroup.controls.ccEmailAddress.dirty ||
                  outboundFeedFormGroup.controls.ccEmailAddress.touched)
                  ) {
                  <inm-validation-message
                    [control]="outboundFeedFormGroup.controls.ccEmailAddress"
                    [label]="'.fields.ccEmailAddress.label' | staticContent"
                    >
                  </inm-validation-message>
                }
                <small class="text-muted float-end"
                  >{{ outboundFeedFormGroup.controls?.ccEmailAddress?.value?.length || 0 }} / 255</small
                  >
                </inm-input-container>
              </div>
            </div>
          }

          <div class="row">
            <inm-input-container [label]="'.fields.notes.label' | staticContent" class="col-12" [optional]="true">
              <textarea
                [placeholder]="'.fields.notes.placeholder' | staticContent"
                formControlName="notes"
                id="notes"
                [maxLength]="500"
                [readonly]="false"
                class="inm-textinput__input"
                >
              </textarea>

              <small class="text-muted float-end">{{ outboundFeedFormGroup.controls?.notes?.value?.length || 0 }} / 500</small>
            </inm-input-container>
          </div>
        </inm-panel>
